module.exports = __webpack_public_path__ + "img/ic_upload_File_1.31c535f5.svg";